import styled from 'styled-components';
import { ParticipantItem } from 'features/ParticipantItem';

export const ParticipantsArea = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media screen and (orientation: landscape) {
        flex-direction: column;
        overflow-y: scroll;
        overflow-x: auto;
        height: 100%;
    }

    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

export const ParticipantWrapper = styled.div`
    flex-shrink: 0;
    width: 180px;

    @media screen and (orientation: landscape) {
        width: 100%;
        height: auto;
    }
`;

export const MobileParticipant = styled(ParticipantItem)`
    width: 100%;
    height: 100%;
`;
